(function () {
  'use strict';

  let angular = window.angular;

  Controller.$inject = [
    '$rootScope',
    'Customer',
    '$timeout',
    '$state',
    '$uibModal',
    'assetUtilsService',
    'AppUtils',
  ];

  angular.module('app').component('connectionEmergencyContact', {
    template:'<view-sidebar><view-sidebar-title><span translate>entities.emergencycontact.modelName</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary" title="{{:: \'buttons.new\' | translate}} {{:: \'entities.emergencycontact.modelName\' | translate}}" ng-click="ctrl.showEmergencyContactForm(null, null)"><i class="fas fa-plus"></i></a> <a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.emergencyContactId}" ui-sref=".({emergencyContactId: null})"><i class="fas fa-ban"></i></a></div></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.emergencyContactsTree" selected="ctrl.emergencyContactId" on-select="ctrl.onSelectEmergencyContact(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.emergencyContactSelected || ctrl.loading"><h1 class="centered-message no-margin"><i class="fas fa-arrow-circle-left"></i> <span translate>general._select.an</span> <span translate>entities.emergencycontact.modelName</span></h1></div><div ng-if="ctrl.emergencyContactSelected" ng-show="!ctrl.loading"><div class="asset-profile"><div class="padding20"><div class="asset-name"><div><h2 title="{{ctrl.emergencyContactSelected.name}}">{{ctrl.emergencyContactSelected.name}}</h2><div class="btn-group"><a class="btn btn-primary btn-sm" ng-click="ctrl.showEmergencyContactForm(ctrl.emergencyContactSelected)"><i class="fas fa-edit"></i></a> <a class="btn btn-danger btn-sm" ng-click="ctrl.confirmRemoveEmergencyContact(ctrl.emergencyContactSelected)"><i class="fas fa-trash"></i></a></div><div class="clearfix"></div></div></div><table class="table no-margin table-description"><thead><tr><th colspan="4" class="no-padding"></th></tr></thead><tbody><tr class="bordered"><td class="field">Id</td><td colspan="3" class="clipboard" style="cursor: copy" clipboard data-text="ctrl.emergencyContactSelected.id">{{ctrl.emergencyContactSelected.id}} <button class="btn btn-default btn-sm btn-clipboard" title="Copy to clipboard"><i class="fas fa-copy"></i></button></td></tr><tr class="bordered"><td class="field" translate>entities.emergencycontact.phone</td><td colspan="3" class="clipboard">{{ctrl.emergencyContactSelected.phone}}</td></tr><tr><td class="field" translate>entities._all.description</td><td colspan="3" data-label="Description" class="block"><div class="asset-description" data-label="{{:: \'buttons.expand\' | translate}}" ng-class="{\'opened\': ctrl.showDescription, \'gradient\': ctrl.emergencyContactSelected.description}" ng-click="ctrl.showDescription = true"><div id="emergencyContactDescription" class="markdown" markdown-to-html="ctrl.emergencyContactSelected.description || \'\'"></div></div><div ng-if="ctrl.showDescription" style="text-align: center" class="asset-description"><a class="contraction-text" ng-click="ctrl.showDescription=false" translate>buttons.hide</a></div></td></tr></tbody></table></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      emergencyContacts: '<',
      customer: '<',
    },
  });

  function Controller(
    $rootScope,
    Customer,
    $timeout,
    $state,
    $uibModal,
    assetUtilsService,
    appUtils
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.onSelectEmergencyContact = onSelectEmergencyContact;

      vm.emergencyContactsTree = vm.emergencyContacts.tree;
      vm.emergencyContacts = appUtils.arrayToObject(vm.emergencyContacts.emergencyContacts, 'id');

      // modals
      vm.showEmergencyContactForm = showEmergencyContactForm;
      vm.confirmRemoveEmergencyContact = confirmRemoveEmergencyContact;
      vm.emergencyContactSelected = null;

      checkIdParam(vm.$transition$.params().emergencyContactId);

      vm.uiOnParamsChanged = function (params) {
        if (params.emergencyContactId !== undefined) {
          checkIdParam(params.emergencyContactId);
        }
      };
    };

    function showEmergencyContactForm(emergencyContact) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        keyboard: false,
        component: 'connectionEmergencyContactForm',
        resolve: {
          emergencyContact: emergencyContact,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function (result) {
          if (result.operation === 'create') {
            $state.go('.', { emergencyContactId: result.emergencyContact.id }, { reload: true });
          } else if (result.operation === 'update') {
            if (emergencyContact.name !== result.emergencyContact.name) {
              $rootScope.$broadcast('jstree.rename-node', result.node);
            }

            onSelectEmergencyContact(result.emergencyContact.id);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function onSelectEmergencyContact(selected) {
      if (!selected) {
        vm.emergencyContactSelected = null;
        return;
      }

      $state.go('.', { emergencyContactId: selected });

      vm.loading = true;
      Customer.emergencyContacts({
        id: vm.customer.id,
        filter: {
          where: { id: selected },
        },
      })
        .$promise.then(function (result) {
          const emergencyContact = result[0];

          vm.emergencyContactSelected = emergencyContact;

          vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function confirmRemoveEmergencyContact(emergencyContact) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        windowClass: 'modal-xs modal-warning',
        bindToController: true,
        keyboard: false,
        component: 'connectionEmergencyContactRemove',
        resolve: {
          emergencyContact: emergencyContact,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function () {
          $state.go('.', { emergencyContactId: null }, { reload: true });
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function checkIdParam(emergencyContactIdParam) {
      if (emergencyContactIdParam) {
        if (vm.emergencyContacts[emergencyContactIdParam]) {
          vm.emergencyContactId = emergencyContactIdParam;
        } else {
          $state.go('.', { emergencyContactId: null });
        }
      } else {
        vm.emergencyContactId = null;
      }
    }
  }
})();
